import { Link as SolitoLink } from 'solito/link'

import Box from 'app/components/base/Box/'
import Image from 'app/components/base/Image'
import Link from 'app/components/base/Link'
import Skeleton from 'app/components/base/Skeleton'
import Stack, { StackProps } from 'app/components/base/Stack'
import { IMAGE_PRIORITY_INDEX } from 'app/utils/constants/blog.constants'
import { isOfType } from 'app/utils/helpers/type.helpers'

import CreatedAt from './CreatedAt'

interface ArticleCardMinifiedProps {
  sx?: StackProps['sx']
  link: string
  image: string
  createdAt: string
  title: string
  loading?: boolean
  isMobile?: boolean
  index?: number
  imageAltText?: string
}

const ArticleCardMinified: RFC<ArticleCardMinifiedProps> = ({
  image,
  createdAt,
  title,
  link,
  loading,
  isMobile,
  index,
  imageAltText,
  sx
}) => {
  return (
    <Stack sx={{ columnGap: 2, flexDirection: 'row', ...sx }}>
      <Skeleton
        loading={loading}
        variant="rectangular"
        width={100}
        height={100}
        sx={{ borderRadius: 1 }}
      >
        <SolitoLink
          href={link}
          {...(isMobile && { prefetch: false })}
          aria-label={`Read article ${title}`}
        >
          <Box
            sx={{
              flexShrink: 0,
              borderRadius: 1,
              overflow: 'hidden',
              width: 100,
              height: 100
            }}
          >
            <Image
              src={image}
              alt={imageAltText || title}
              sizes="128px"
              width={100}
              height={100}
              {...(isOfType.number(index) && {
                priority: IMAGE_PRIORITY_INDEX.includes(index)
              })}
            />
          </Box>
        </SolitoLink>
      </Skeleton>

      <Stack sx={{ flexDirection: 'column', flexGrow: 2 }}>
        <Skeleton
          loading={loading}
          width="100%"
          height="24px"
          sx={{ mb: 1, mt: 0.5 }}
        >
          <Link
            href={link}
            variant="h3"
            {...(isMobile && { prefetch: false })}
            lineClamp={1}
            sx={{ mb: 1, mt: 0.5, pr: 0.5 }}
          >
            {title}
          </Link>
        </Skeleton>

        <Skeleton loading={loading} width="30%" height="22px">
          <CreatedAt date={createdAt} />
        </Skeleton>
      </Stack>
    </Stack>
  )
}

export default ArticleCardMinified
